// extracted by mini-css-extract-plugin
module.exports = {"root":"P_bj"};